import { useRouter } from 'next/router';

/* Types */
import type { AppProps } from 'next/app';

/* Tailwind */
import '../styles/globals.css';

/* Globals */
import '@helpers/globals';
import { useEffect } from 'react';

export default function MyApp({ Component, pageProps }: AppProps) {
  const router = useRouter();
  useEffect(() => {
    // Set SEA cookie
    const utmContent = new URL(router.asPath, process.env.NEXT_PUBLIC_BASE_URL).searchParams.get('utm_content');
    if (utmContent) {
      sessionStorage.setItem('utm_content', utmContent);
    }
  }, [ router.asPath ]);

  return (
    <>
      <Component { ...pageProps } />
    </>
  );
}
